import React, { useEffect, useState } from "react";
import { Field, reduxForm } from "redux-form";
import Titlebanner from "../../../globel_cmponents/title_banner";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import RenderField from "../../formcomponent/formfields/RenderField";
import axios from "axios";
import requests from "../../../utils/Requests";
import Swal from "sweetalert2";

import { useHistory, useParams } from "react-router-dom";
const CreateMealsOption = (props) => {
  const { handleSubmit } = props;

  const history = useHistory();
  const { id } = useParams();
  const [hotemIdList, stHotelIdList] = useState([]);
  const [mealTypeList, setMealTypeList] = useState([]);
  useEffect(() => {
    getHotelList();
    getMealTypeList();
  }, []);

  const getHotelList = async () => {
    await axios
      .post(requests.getMealHotelList, { hotelId: 1 })
      .then((res) => {
        console.log(res.data);
        const processData = res.data.map((item) => ({
          value: item.mealHotelId,
          name: item.hotelName,
        }));
        stHotelIdList(processData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getMealTypeList = () => {
    axios
      .post(requests.getMealTypeList, { hotelId: 1 })
      .then((res) => {
        console.log(res.data);
        const processData = res.data.map((item) => ({
          value: item.mealTypeId,
          name: item.mealName,
        }));
        setMealTypeList(processData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (id != "null") {
      getMealTypeDetails();
    }
  }, [id]);

  const getMealTypeDetails = async () => {
    await axios
      .post(requests.getMealOptions, { mealOptionsId: id })
      .then((res) => {
        console.log(res.data);

        props.initialize({
          ...res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const postToApi = async (values) => {
    console.log(values);
    await axios
      .post(requests.createMealOptions, values)
      .then((res) => {
        console.log(res.data);
        Swal.fire("success", "Meals Option Added", "success");
        history.push("/Meals/MealsHotellist/hotel-mealsoption-list");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <Titlebanner title="Create Meals Type" />

      <Card>
        <CardBody>
          <Row>
            <Col>
              <Field
                name="mealHotelId"
                type="select"
                label="Hotel Name"
                customfeild={hotemIdList}
                component={RenderField.renderOptionField}
              />
            </Col>
            <Col>
              <Field
                name="mealTypeId"
                type="select"
                label="Meal Type Name"
                customfeild={mealTypeList}
                component={RenderField.renderOptionField}
              />
            </Col>
            <Col>
              <Field
                name="name"
                label="Name"
                component={RenderField.RenderTextField}
              />
            </Col>

            <Col>
              <Field
                name="actualPrice"
                label="Actual Price"
                component={RenderField.RenderTextField}
              />
            </Col>
            <Col>
              <Field
                name="offerPrice"
                label="Offer Price"
                component={RenderField.RenderTextField}
              />
            </Col>
          </Row>

          <div className="float-right">
            <Button
              color="primary"
              onClick={handleSubmit((values) =>
                postToApi({
                  ...values,
                  pill: 1,
                })
              )}
            >
              Save
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default reduxForm({
  form: "CreateMealsOption",
})(CreateMealsOption);
